import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { RefreshCw } from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface EditUserForm {
  first_name: string
  last_name: string
  display_name: string
  language: string
  timezone: string
}

interface EditUserDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  form: EditUserForm
  onFormChange: (form: EditUserForm) => void
  onSubmit: () => void
  isLoading: boolean
}

export function EditUserDialog({
  open,
  onOpenChange,
  form,
  onFormChange,
  onSubmit,
  isLoading,
}: EditUserDialogProps) {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('admin.users.editUser')}</DialogTitle>
          <DialogDescription>{t('admin.users.editUserDescription')}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label htmlFor="first_name">{t('admin.users.firstName')}</Label>
            <Input
              id="first_name"
              value={form.first_name}
              onChange={e => onFormChange({ ...form, first_name: e.target.value })}
            />
          </div>
          <div>
            <Label htmlFor="last_name">{t('admin.users.lastName')}</Label>
            <Input
              id="last_name"
              value={form.last_name}
              onChange={e => onFormChange({ ...form, last_name: e.target.value })}
            />
          </div>
          <div>
            <Label htmlFor="display_name">{t('admin.users.displayName')}</Label>
            <Input
              id="display_name"
              value={form.display_name}
              onChange={e => onFormChange({ ...form, display_name: e.target.value })}
            />
          </div>
          <div>
            <Label htmlFor="language">{t('admin.users.language')}</Label>
            <Input
              id="language"
              value={form.language}
              onChange={e => onFormChange({ ...form, language: e.target.value })}
            />
          </div>
          <div>
            <Label htmlFor="timezone">{t('admin.users.timezone')}</Label>
            <Input
              id="timezone"
              value={form.timezone}
              onChange={e => onFormChange({ ...form, timezone: e.target.value })}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isLoading}>
            {t('admin.users.cancel')}
          </Button>
          <Button onClick={onSubmit} disabled={isLoading}>
            {isLoading ? <RefreshCw className="h-4 w-4 animate-spin mr-2" /> : null}
            {t('admin.users.save')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
